import { render } from "./MsDropDownButton.vue?vue&type=template&id=5331c6f9&scoped=true"
import script from "./MsDropDownButton.vue?vue&type=script&lang=js"
export * from "./MsDropDownButton.vue?vue&type=script&lang=js"

import "./MsDropDownButton.vue?vue&type=style&index=0&id=5331c6f9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5331c6f9"]])

export default __exports__